module.exports = __webpack_public_path__ + "app-static/img/icon_yuyue.1664dd88.png";